import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@/shared/api/errors';
import { queryKeys } from '@/shared/lib/query/queryKeys';
import {
  fetchWishlist,
  toggleWishlist,
  type WishlistListFilter,
} from './wishlistApi';

export function useWishlistQuery(filter: WishlistListFilter) {
  return useQuery({
    queryKey: queryKeys.wishlist.list(filter),
    queryFn: () => fetchWishlist(filter),
    refetchOnWindowFocus: false,
  });
}

export function useToggleWishlistMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (billboardId: string) => toggleWishlist(billboardId),
    onSuccess: (data) => {
      toast.success(
        (data as { message?: string })?.message || 'Wishlist updated',
      );
      void queryClient.invalidateQueries({ queryKey: queryKeys.wishlist.root });
      void queryClient.invalidateQueries({ queryKey: queryKeys.billboards.root });
    },
    onError: (error) => {
      toast.error(getErrorMessage(error, 'Failed to update wishlist'));
    },
  });
}
